<template>
  <div class="layout">
      <div class="title">
          <Icon type="ios-arrow-back" class="arrow" @click="handleClick()"/>
          <span>{{$t('message.A_query_result')}}</span>
      </div>
      <router-view></router-view>
  </div>
</template>

<script>
  export default {
      name: "A_query_result",
      methods: {
          handleClick() {
              this.$router.push({name: 'Home'});
          }
      }
  }
</script>

<style>
  .ivu-layout {
      background: none;
  }
  
  .ivu-upload-select {
      width: 100%;
  }
  
  .ivu-select-selection {
      border: none !important;
  }
  
  .ivu-select-visible .ivu-select-selection {
      outline: none !important;
      box-shadow: none !important;
  }
  
  .layout {
      /*margin: 0 1rem 0 1rem;*/
      /*padding-top: 1rem;*/
      max-width: 1024px;
      margin: 0 auto;
  }
  
  .title {
      font-size: 0.4rem;
      margin-bottom: 0.5rem;
      position: relative;
      /*margin-top: 0.15rem;*/
      padding-top: 0.15rem;
  }
  
  .arrow {
      position: absolute;
      left: 0;
      top: 0.25rem;
  }
  
  .hint {
      font-size: 0.3rem;
      color: #000000;
      margin-bottom: 3.2rem;
      margin-top: 0.46rem;
  }
  
  .btn {
      font-size: 0.36rem;
  }
  
  .text-cur {
      font-size: 0.26rem;
      color: #999999;
  }
  
  .text-act {
      font-size: 0.3rem;
      color: #f64b49;
      margin-bottom: 0.34rem;
      margin-top: 0.24rem;
  }
  
  .loader-overlay {
      display: none;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 98;
      width: 100%;
      height: 100%;
      overflow-y: hidden;
      background: rgba(0, 0, 0, 0.4);
  }
  
  .loader,
  .loader:after {
      border-radius: 50%;
      width: 80px;
      height: 80px;
  }
  
  .loader {
      margin: 0 auto;
      font-size: 10px;
      position: fixed;
      top: calc(50% - 40px);
      left: calc(50% - 40px);
      text-indent: -9999em;
      border-top: 1.1em solid rgba(255, 255, 255, 0.2);
      border-right: 1.1em solid rgba(255, 255, 255, 0.2);
      border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);
      border-left: 1.1em solid #ffffff;
      -webkit-transform: translateZ(0);
      -ms-transform: translateZ(0);
      transform: translateZ(0);
      -webkit-animation: loading-animation 1.1s infinite linear;
      animation: loading-animation 1.1s infinite linear;
  }
  
  @keyframes loading-animation {
      from {
          transform: rotate(0deg);
      }
      to {
          transform: rotate(360deg);
      }
  }
  
  @-moz-keyframes loading-animation /* Firefox */
  {
      from {
          transform: rotate(0deg);
      }
      to {
          transform: rotate(360deg);
      }
  }
  
  @-webkit-keyframes loading-animation /* Safari 和 Chrome */
  {
      from {
          transform: rotate(0deg);
      }
      to {
          transform: rotate(360deg);
      }
  }
  
  @-o-keyframes loading-animation /* Opera */
  {
      from {
          transform: rotate(0deg);
      }
      to {
          transform: rotate(360deg);
      }
  }
  
  .ivu-btn-primary {
      background-color: #ff5500 !important;
      border-color: #ff5500 !important;
  }
  
  .button_file {
      border-color: #ff5500 !important;
  }
  
  .chi_sel .ivu-select-selected-value, .chi_sel .ivu-select-arrow {
      font-size: 18px !important;
  }
  
  .container {
      padding: 0 0.5rem;
  }
  
  .split-line {
      width: 100%;
      height: 0.2rem;
      background-color: #f5f5f5;
      margin-top: 0.68rem;
  }
  
  input, textarea {
      -webkit-appearance: none;
      -moz-appearance: none;
      -ms-appearance: none;
      background-color: #f5f5f5 !important;
      color: #000000 !important;
  }
  
  .hint-img {
      width: 1.8rem;
      margin: 0 auto;
      max-width: 140px;
  }
  
  .hint-img img {
      width: 100%;
  }
</style>
